import { Box, Grid, Typography, styled, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { DefaultUrlWeb } from "config/Configuration";
import FancyCard from "components/FancyCard";
import NumberFormats from "components/NumberFormats";
import { useParams } from "react-router-dom";
import useDispatch from "hooks/useDispatch";
import { getBasketWalletInfo, getPortfolioWalletInfo } from "store/slices/wallet/walletSlice";
import { useSelector } from "react-redux";

export function WalletCard({ isBasket }) {
  const dispatch = useDispatch()
  const portfolioWalletInfo = useSelector((state) => state.wallet.portfolioWalletInfo?.data)

  const theme = useTheme();

  const { id, portfolioId } = useParams()

  const [loading, setLoading] = useState(false)

  const handleGetPortfolioInfo = async () => {
    setLoading(true)

    if (isBasket) {
      await dispatch(getBasketWalletInfo({ id, portfolioId }))
    } else {
      await dispatch(getPortfolioWalletInfo({ id }))
    }

    setLoading(false)
  }

  useEffect(() => {
    handleGetPortfolioInfo()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioId, id]);

  return (
    <>
      {!loading ? (
        <FancyCard color={theme.palette.background.blue}>
          <Grid container spacing={4}>
            <BoxDate>
              <Typography component="small">
                {portfolioWalletInfo?.date} <br /> {portfolioWalletInfo?.time}
              </Typography>
            </BoxDate>

            <TypographyTitle item xs={12}>
              <Typography
                variant="h4"
                color="common.white"
                fontWeight={700}
              >
                Wallet
              </Typography>
            </TypographyTitle>

            <Grid item sm={6} md={3} xs={12}>
              <Typography
                variant="h5"
                color="common.white"
                fontWeight={600}
                marginBottom={2.3}
              >
                Total Value Balance
              </Typography>

              <BoxCoin>
                <img src={DefaultUrlWeb + portfolioWalletInfo?.baseCoinImageUrl} alt={portfolioWalletInfo?.baseCoinName} />
                <Typography variant="h3" color="common.white" fontWeight={400}>
                  <NumberFormats value={portfolioWalletInfo?.totalBalanceBaseCoin} />
                  <Typography component="small" fontWeight={300}>
                    {portfolioWalletInfo?.baseCoinName}
                  </Typography>
                </Typography>
              </BoxCoin>
            </Grid>

            <Grid item sm={6} md={3} xs={12}>
              <Typography
                variant="h5"
                color="common.white"
                fontWeight={600}
                marginBottom={2.3}
              >
                Debit
              </Typography>

              <BoxCoin>
                <img src={DefaultUrlWeb + portfolioWalletInfo?.baseCoinImageUrl} alt={portfolioWalletInfo?.baseCoinName} />
                <Typography variant="h3" color="common.white" fontWeight={400}>
                  <NumberFormats value={portfolioWalletInfo?.debtBaseCoin} />
                  <Typography component="small" fontWeight={300}>
                    {portfolioWalletInfo?.baseCoinName}
                  </Typography>
                </Typography>
              </BoxCoin>
            </Grid>

            <Grid item sm={6} md={3} xs={12}>
              <Typography
                variant="h5"
                color="common.white"
                fontWeight={600}
                marginBottom={2.3}
              >
                Equity
              </Typography>

              <BoxCoin>
                <img src={DefaultUrlWeb + portfolioWalletInfo?.baseCoinImageUrl} alt={portfolioWalletInfo?.baseCoinName} />
                <Typography variant="h3" color="common.white" fontWeight={400}>
                  <NumberFormats value={portfolioWalletInfo?.equityBaseCoin} />
                  <Typography component="small" fontWeight={300}>
                    {portfolioWalletInfo?.baseCoinName}
                  </Typography>
                </Typography>
              </BoxCoin>
            </Grid>

            <Grid item sm={6} md={3} xs={12}>
              <Typography
                variant="h5"
                color="common.white"
                fontWeight={600}
                marginBottom={2.3}
              >
                Margin Level
              </Typography>

              <BoxCoin>
                <img src={DefaultUrlWeb + portfolioWalletInfo?.baseCoinImageUrl} alt={portfolioWalletInfo?.baseCoinName} />
                <Typography variant="h3" color="common.white" fontWeight={400}>
                  <NumberFormats value={portfolioWalletInfo?.marginLevel} />
                  <Typography component="small" fontWeight={300}>
                    {portfolioWalletInfo?.baseCoinName}
                  </Typography>
                </Typography>
              </BoxCoin>
            </Grid>
          </Grid>
        </FancyCard>
      ) : (
        <CardSkeleton heightSize={208} />
      )}
    </>
  );
}

const BoxDate = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  right: "20px",
  color: `${theme.palette.text.main}90`,
  fontWeight: "300",
  fontSize: "12px",
  lineHeight: "18px",
  textAlign: "right",
  small: {
    color: theme.palette.common.white,
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "end",
  },
}));

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1.3),
  img: {
    width: "25px",
    marginRight: theme.spacing(1),
  },
  small: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.7),
  },
}));

const TypographyTitle = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export default WalletCard;
